import { SideWithAsset } from 'shared-types';

// side === null: placeholder voor een positie waar nog geen side voor bestaat (het product
// verwacht sidesCount pagina's, maar er zijn er nog minder geüpload).
export type Slot = { side: SideWithAsset | null; index: number } | null;
export type Spread = Slot[];

// Setje 0 is de cover: lege plek links, pagina 1 rechts. Daarna telkens twee opeenvolgende
// pagina's (2|3, 4|5, ...). Producten met maar 1-2 zijden (flyers, borden) hebben geen rug, dus
// die krijgen ieder een eigen setje zonder lege plek — zelfde regel als in BookPreviewModal.
// `totalSlots` (normaal session.sidesCount) vult aan met placeholders tot het verwachte aantal;
// zijn er méér sides dan verwacht, dan worden die gewoon getoond.
export const buildSpreads = (sides: SideWithAsset[], totalSlots = sides.length): Spread[] => {
  const count = Math.max(sides.length, totalSlots, 0);
  const slots: Slot[] = Array.from({ length: count }, (_, index) => ({
    side: sides[index] ?? null,
    index,
  }));
  if (slots.length <= 2) return slots.map((slot) => [slot]);

  const spreads: Spread[] = [[null, slots[0]]];
  for (let i = 1; i < slots.length; i += 2) {
    spreads.push([slots[i], slots[i + 1] ?? null]);
  }
  return spreads;
};
